import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar } from '@mui/material';
import { useEntityContext } from '../context';
import { useAuthContext } from '../../../state/providers/auth';

import './index.scss';

function EntityHeader() {
  const { currentEntity, userData, entityTypes } = useEntityContext();
  const {
    isLoggedIn
  } = useAuthContext();

  return (
    <div className="header">
      <div className="user-info">
        <Link to={`/user/${userData.username}`}>
          <Avatar
            alt={userData.name}
            src={`https://github.com/${userData?.githubUsername}.png`}
            className="profile-avatar"
            sx={{ width: 25, height: 25 }}
          />
        </Link>

        <div className="user-details">
          <Link to={`/user/${userData.username}`} className="username">
            {userData.username}
          </Link>
          <span className="separating-slash">/</span>
          <Link to={`/${userData.username}/entity/${currentEntity.id}`} className="username">
            {currentEntity.name}
          </Link>
          <div className="entity-types">
            {Object.entries(entityTypes).map(([type, { id }]) => (
              <Link
                to={`/${userData.username}/entity/${id}`}
                className="entity-type-link"
                key={id}
              >
                <span key={type} className="entity-type-badge">
                  {type}
                </span>
              </Link>
            ))}
          </div>
          { isLoggedIn && (
            <Link to={`/entities/${currentEntity.id}`}>Edit</Link>
          )}
        </div>
      </div>
    </div>
  );
}

export default EntityHeader;
